module.exports = __webpack_public_path__ + "img/laudos.91553ac3.svg";